export * from './minus_icon';
